const paths = {
  arrow: '<path d="M5 12h14m-5-5 5 5-5 5"/>',
  close: '<path d="m6 6 12 12M18 6 6 18"/>',
  collection: '<rect x="8" y="5" width="12" height="16" rx="2"/><path d="M15 5V3H4v15h4m4-9h4m-4 4h4"/>',
  book: '<path d="M12 5c-3-2-7-2-10-1v15c4-1 7-1 10 1m0-15c3-2 7-2 10-1v15c-4-1-7-1-10 1Zm0 0v15"/>',
  settings: '<path d="M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z"/><path d="m9 3 .7-1h4.6l.7 3 2 .9 2.7-1 2.3 4-2.1 2 .1 2.2 2 1.9-2.3 4-2.8-.8-2 1-1 2.8H9.4l-.9-2.8-2-1-2.8.8-2.3-4 2.1-2v-2.2l-2-2 2.3-4 2.7 1 2-.9Z"/>',
  spark: '<path d="m12 2 2.7 7.3L22 12l-7.3 2.7L12 22l-2.7-7.3L2 12l7.3-2.7Z"/>',
  shield: '<path d="M12 2 3 6v6c0 5 9 10 9 10s9-5 9-10V6Z"/><path d="m8 12 3 3 5-6"/>',
  strike: '<path d="m14 2-3 7H5l5 5-2 8 11-13h-6l3-7Z"/>',
  energy: '<circle cx="12" cy="12" r="5"/><path d="M12 1v3m0 16v3M1 12h3m16 0h3M4 4l2 2m12 12 2 2M4 20l2-2M18 6l2-2"/>',
  drill: '<path d="m12 2 9 5-9 5-9-5Zm-9 10 9 5 9-5M3 17l9 5 9-5"/>',
  life: '<path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0l-1 1-1-1a5.5 5.5 0 0 0-7.8 7.8L12 22l8.8-9.6a5.5 5.5 0 0 0 0-7.8Z"/>',
  crown: '<path d="m3 7 4 4 5-7 5 7 4-4-2 12H5Z"/><path d="M6 15h12"/>',
  dragon: '<circle cx="12" cy="12" r="10"/><path d="m12 6 1.6 3.7 4 .3-3 2.7.9 4-3.5-2.1-3.5 2.1.9-4-3-2.7 4-.3Z"/>',
  log: '<path d="M8 5h13M8 12h13M8 19h13"/><circle cx="3" cy="5" r="1"/><circle cx="3" cy="12" r="1"/><circle cx="3" cy="19" r="1"/>',
  flag: '<path d="M4 22V3c5-4 11 4 16 0v11c-5 4-11-4-16 0"/>',
  volume: '<path d="M11 4 5 9H1v6h4l6 5Zm5 4a6 6 0 0 1 0 8m4-12a11 11 0 0 1 0 16"/>',
  motion: '<path d="M3 7h7M1 12h7m-5 5h7m4-13 8 8-8 8Z"/>',
  fullscreen: '<path d="M8 3H3v5m13-5h5v5M3 16v5h5m13-5v5h-5"/>',
  search: '<circle cx="10.5" cy="10.5" r="7.5"/><path d="m16 16 6 6"/>',
  cards: '<rect x="7" y="3" width="14" height="18" rx="2"/><path d="M7 5 2 6l2 15 4-1m3-12h6m-6 4h6m-6 4h4"/>',
  check: '<path d="m5 12 4 4L19 6"/>',
  hand: '<path d="M8 12V5a2 2 0 0 1 4 0v7-9a2 2 0 0 1 4 0v10-7a2 2 0 0 1 4 0v9c0 5-3 7-7 7-3 0-5-1-7-4l-3-5a2 2 0 0 1 3-2l2 1Z"/>',
  rotate: '<path d="M3 9a9 9 0 1 1 0 7m0-7V3m0 6h6"/>',
  chevron: '<path d="m9 5 7 7-7 7"/>',
  info: '<circle cx="12" cy="12" r="10"/><path d="M12 11v6m0-10v.1"/>',
  pause: '<path d="M8 5v14M16 5v14"/>',
} as const;

export type IconName = keyof typeof paths;
export function icon(name: IconName, className = ''): string {
  return `<svg class="ui-icon ${className}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${paths[name]}</svg>`;
}
